import * as React from 'react'
import './lightbox.css'

interface IState {
  count: number
}
export default class LightBox extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      count: 1,
    }
    this.prevImage = this.prevImage.bind(this)
    this.nextImage = this.nextImage.bind(this)
  }

  prevImage() {
    if (this.state.count === 1) {
      this.setState({ count: this.props.content.images.length })
    } else {
      this.setState({ count: this.state.count - 1 })
    }
  }
  nextImage() {
    if (this.props.content.images.length === this.state.count) {
      this.setState({ count: 1 })
    } else {
      this.setState({ count: this.state.count + 1 })
    }
  }

  render() {
    const { content, cancel, companyName, companyUrl } = this.props
    const total = content.images.length
    let translateX = 768 * (this.state.count - 1)
    if (window.innerWidth < 1399) {
      translateX = window.innerWidth * (this.state.count - 1)
    }

    const sizeLabel = 'Stærðir:'
    const colorLabel = 'Litir:'
    const aferdLabel = 'Áferðir:'
    const horkustudullLabel = 'Hörkustuðull:'
    return (
      <div className="overlay-dude">
        <div className="overlay">
          <div className="overlay-close" onClick={cancel}>
            X <span>Esc</span>
          </div>
          <div className="overlay-number">
            {this.state.count}/{total}
          </div>
          <div
            className="overlay-box-prev-contain"
            onClick={() => this.prevImage()}
          >
            <span className="overlay-box-prev" />
          </div>
          <div className="overlay-box">
            <div className="overlay-box-left">
              <div className="overlay-box-left-upper-container">
                <div
                  className="overlay-box-left-container"
                  id="image-container"
                  style={{ transform: 'translate(-' + translateX + 'px,0px)' }}
                >
                  {Object.keys(content.images).map((key) => {
                    return (
                      <div
                        className="overlay-box-left-image"
                        key={key}
                        style={{
                          backgroundImage:
                            'url(' +
                            content.images[key]?.fields?.file?.url +
                            ')',
                        }}
                      />
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="overlay-box-right">
              <a
                href={companyUrl}
                target="_blank"
                className="overlay-box-right-link"
              >
                {companyName}
              </a>
              <div className="overlay-box-right-title">{content.title}</div>
              <div className="overlay-box-right-content">
                {content.text}
                <br />
                {content.strir !== undefined && (
                  <div>
                    <br />
                    {sizeLabel}
                    <p>
                      {content.strir.map((item: any) => (
                        <div>- {item}</div>
                      ))}
                    </p>
                  </div>
                )}
                {content.litir !== undefined && (
                  <div>
                    <br />
                    {colorLabel}
                    <p>
                      {content.litir.map((item: any) => (
                        <div>- {item}</div>
                      ))}
                    </p>
                  </div>
                )}
                {content.fer !== undefined && (
                  <div>
                    <br />
                    {aferdLabel}
                    <p>
                      {content.fer.map((item: any) => (
                        <div>- {item}</div>
                      ))}
                    </p>
                  </div>
                )}
                {content.hrkustuull !== undefined && (
                  <div>
                    <br />
                    {horkustudullLabel}
                    <p>
                      {content.hrkustuull.map((item: any) => (
                        <div>- {item}</div>
                      ))}
                    </p>
                  </div>
                )}
                {content.price !== undefined && (
                  <div>
                    <br />
                    Verð: {content.price}
                  </div>
                )}
              </div>
              {content.litamyndir !== undefined && (
                <div className="overlay-box-litamyndir">
                  <div className="overlay-box-litamyndir-heading">Litir:</div>
                  <div className="overlay-box-litamyndir-images">
                    {content.litamyndir.map((item: any) => {
                      return (
                        <div
                          key={item.fields.file.fileName}
                          className="overlay-box-litamyndir-small"
                        >
                          <img src={item.fields.file.url} />
                          <div className="overlay-box-litamyndir-large">
                            <div
                              className="overlay-box-litamyndir-large-image"
                              style={{
                                backgroundImage: `url(${item.fields.file.url})`,
                              }}
                            />
                            <span>{item.fields.description}</span>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
              {content.pdf?.fields?.file !== undefined && (
                <div className="overlay-box-right-content-pdf">
                  <a
                    href={content.pdf.fields.file.url}
                    className="pdf"
                    target="_blank"
                  >
                    Sækja bækling
                  </a>
                </div>
              )}
              <div className="overlay-box-share">
                <div className="overlay-box-share-facebook overlay-box-share-button">
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                    target="_blank"
                  >
                    <img src="/images/Facebook.svg" height="20" />
                  </a>
                </div>
                <div className="overlay-box-share-twitter overlay-box-share-button">
                  <a
                    href={`https://twitter.com/share?url=${window.location.href}`}
                    target="_blank"
                  >
                    <img src="/images/twitter.svg" width="22" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            className="overlay-box-next-contain"
            onClick={() => this.nextImage()}
          >
            <span className="overlay-box-next" />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/lightbox/lightbox.tsx